// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"c6ca9f9a","127":"c00ada9f","146":"7eb0c400"}[chunkId] + ".chunk.css";
};